import { render, staticRenderFns } from "./bscClueZhaoBiaoList.vue?vue&type=template&id=2011454a&scoped=true"
import script from "./bscClueZhaoBiaoList.vue?vue&type=script&lang=js"
export * from "./bscClueZhaoBiaoList.vue?vue&type=script&lang=js"
import style0 from "./bscClueZhaoBiaoList.vue?vue&type=style&index=0&id=2011454a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2011454a",
  null
  
)

export default component.exports